import allSettled from 'hs-promise-utils/allSettled';

/**
 * hs-promise-utils/allSettled (https://git.hubteam.com/HubSpot/hs-promise-utils/tree/master/hs-promise-utils#hs-promise-utilsallsettled)
 * is typed for arrays but not tuples, which makes it hard to use with promises that resolve to different types
 *
 * We could just cast it to `as typeof Promise.allSettled`, but the hs-promise-utils version can't handle as many cases (eg Iterables)
 * so it's a potentially unsafe cast.
 * So instead we're just copy-pasting Promise.allSettled's array override type here
 */

export default allSettled;